import { watch } from "vue";

const loadedFonts = new Set();

/**
 * Loads a Google Font via webfontloader. Uses a module-level cache to prevent duplicate loads.
 *
 * @param {import('vue').Ref<string | null>} fontFamilyRef - Reactive ref containing the font family name
 */
// eslint-disable-next-line import/prefer-default-export
export function useGoogleFont(fontFamilyRef) {
  watch(
    fontFamilyRef,
    fontFamily => {
      if (!fontFamily || loadedFonts.has(fontFamily)) return;

      loadedFonts.add(fontFamily);

      import("webfontloader").then(WebFont => {
        WebFont.load({
          google: { families: [fontFamily] }
        });
      });
    },
    { immediate: true }
  );
}
